"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../themes/spring2024/components/ebooks/ebook-1");
require("../lib/layout/btnEventHandler");
require("../lib/layout/falling-section");
require("./form");
const addSelectCountry_1 = require("../forms/addSelectCountry");
const contactNumbers_1 = require("../forms/utils/contactNumbers");
const contactNumbers = new contactNumbers_1.ContactNumbers;
document.addEventListener('DOMContentLoaded', () => {
    (0, addSelectCountry_1.insertSelect)();
    contactNumbers.setContactNumber('Default');
});
